
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createBasicGraphNodeClicker, DashboardGraph, PieChart } from 'graph'
import { useGraphFetch, constants } from '../module'
import { useSelectedFleetIds } from 'features/settings'
import { v4 as uuid } from 'uuid'
import Typography from '@mui/material/Typography'

const Graph = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selectedFleetIds = useSelectedFleetIds()

  const { loading, error, data } = useGraphFetch()
  const path = '/fleet?showColumns=fuelType'

  const onClick = createBasicGraphNodeClicker((label) => {
    if (!label) {
      return
    }

    const value = label.split('(')[0].trim()
    const fuelMap = {
      Diesel: 'Diesel',
      Petrol: 'Petrol',
      Hybrid: 'Hybrid',
      Electric: 'Electric',
      'Premium Unleaded': 'Petrol',
    }

    const fuelType = fuelMap[value]

    if (fuelType) {
      navigate(`${path}?showColumns=fuelType&fuelType=${encodeURIComponent(fuelType)}`)
      return
    }

    navigate(`${path}?status=${encodeURIComponent(value)}`)
  })

  const onRefresh = () => {
    dispatch({
      type: constants.REQUEST_DATA,
      payload: null,
      options: {
        queryParams: { FleetId: selectedFleetIds.join() },
        requestId: uuid(),
      },
    })
  }

  const hasData =
    data && data.values && data.values.filter((x) => x !== 0).length !== 0

  return (
    <DashboardGraph
      title="Fleet Composition"
      to={path}
      loading={loading}
      error={error}
      onRefresh={onRefresh}
      data={data}>
      {hasData ? (
        <div
          style={{ height: '100%', position: 'relative' }}>
          <PieChart data={data} onClick={onClick} />

          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              lineHeight: '20px',
              padding: '2px 8px',
              backgroundColor: '#FFF9',
              fontSize: 13,
              color: '#666'
            }}>
            Total Fleet size {data.totalFleetSize}<br />
              Average age: {data.averageAge} yrs<br />
            {data.passengerPercent}% Passenger<br />
            {data.commercialPercent}% Commercial
          </div>
        </div>
      ) : (
        <Typography variant="h5" textAlign="center">
          Our current data shows that you have no fleet composition data
          available.
        </Typography>
      )}
    </DashboardGraph>
  )
}

export default Graph
